<template>
    <CRow>
        <CCol col="12">
            <CCard>
                <CCardBody>
                    <ValidationObserver ref="form" v-slot="{ invalid, handleSubmit }" class="col" tag="div">
                        <CElementCover v-show="showLoading" :opacity="0.8" style="z-index:1"/>
                        <CForm method="post" @submit.prevent="handleSubmit(submit)">
                            <span class="badge badge-danger p-2 w-100 mb-2">{{ errMessage }}</span>
                            <CRow>
                                <CCustomSelect
                                    v-model="obj.status"
                                    :name="$t('membership_request.status')"
                                    :options="membershipRequestStatusOption"
                                    required
                                    rules="required"
                                    sm="3"
                                    vid="status"
                                />
                                <CCustomTextarea
                                    v-if="obj.status === MembershipRequestStatus.REJECTED"
                                    v-model="obj.reject_reason"
                                    :name="$t('membership_request.reject_reason')"
                                    required
                                    rules="required"
                                    sm="12"
                                    vid="reject_reason"
                                />
                            </CRow>
                            <CButton :disabled="invalid" class="mt-3 px-4" color="primary" type="submit">
                                {{ $t('submit') }}
                            </CButton>
                        </CForm>
                    </ValidationObserver>
                </CCardBody>
            </CCard>
        </CCol>
        <CCol col="12">
            <CCard>
                <CCardBody>
                    <p>
                        <span class="font-weight-bold">{{ $t('membership_request.status') }}: </span>
                        <span :class="'badge badge-'+statusColor(membershipRequest.status)">
                            {{ status(membershipRequest.status) }}
                        </span>
                    </p>
                    <p>
                        <span class="font-weight-bold">{{ $t('membership_request.type._') }}: </span>
                        {{ setType(membershipRequest.type) }}
                    </p>
                    <p>
                        <span class="font-weight-bold">
                            {{ $t('membership_request.full_name') }}:
                        </span>
                        {{ membershipRequest.full_name }}
                    </p>
                    <p>
                        <span class="font-weight-bold">
                            {{ $t('membership_request.mobile') }}:
                        </span>
                        {{ membershipRequest.mobile }}
                    </p>
                    <p>
                        <span class="font-weight-bold">
                            {{ $t('membership_request.email') }}:
                        </span>
                        {{ membershipRequest.email }}
                    </p>
                    <p v-if="isRejected">
                        <span class="font-weight-bold">
                            {{ $t('membership_request.reject_reason') }}:
                        </span>
                        {{ membershipRequest.reject_reason }}
                    </p>
                    <p>
                        <span class="font-weight-bold">
                            {{ $t(`membership_request.${isPublisher ? 'media' : 'site'}`) }}:
                        </span>
                        <CLink :href="membershipRequest.site" target="_blank">
                            <FaIcon class="mx-2" icon="link"></FaIcon>
                        </CLink>
                        {{ membershipRequest.site }}
                    </p>
                    <p>
                        <span class="font-weight-bold">
                            {{ $t(`membership_request.${isPublisher ? 'media_name' : 'site_name'}`) }}:
                        </span>
                        <span v-html="membershipRequest.site_name"></span>
                    </p>
                    <p v-if="isPublisher">
                        <span class="font-weight-bold">
                            {{ $t('membership_request.description') }}:
                        </span>
                        {{ membershipRequest.description }}
                    </p>
                    <p>
                        <span class="font-weight-bold">
                            {{ $t('membership_request.acquaintance') }}:
                        </span>
                        {{ membershipRequest.acquaintance }}
                    </p>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { MembershipRequestStatus, MembershipRequestType } from "@/constants";
import { setType, status, statusColor } from "@/views/membershipRequests/partials/methods";
import CCustomSelect from "@/components/form/CCustomSelect";
import { membershipRequestStatusOption } from "@/common/data";

export default {
    name: "MembershipRequestDetails",
    components: { CCustomSelect },

    data() {
        return {
            obj: {
                status: '',
                reject_reason: ''
            },
            MembershipRequestStatus,
            MembershipRequestType,
            id: this.$route.params.id,
            membershipRequestStatusOption,
            errMessage: '',
            showLoading: false
        }
    },

    computed: {
        ...mapGetters('membershipRequest', [
            'membershipRequestById'
        ]),
        membershipRequest() {
            return this.membershipRequestById(this.id)
        },
        isPublisher() {
            return this.membershipRequest.type === MembershipRequestType.PUBLISHER
        },
        isMerchant() {
            return this.membershipRequest.type === MembershipRequestType.MERCHANT
        },
        isRejected() {
            return this.membershipRequest.status === MembershipRequestStatus.REJECTED
        }
    },

    methods: {
        status,
        setType,
        statusColor,
        ...mapActions({
            edit: 'membershipRequest/edit'
        }),
        submit() {
            const data = this.obj
            data.id = this.id
            this.showLoading = true

            this.edit(data).then(() => {
                this.membershipRequest.reject_reason = this.obj.reject_reason
                this.membershipRequest.status = this.obj.status
                this.showLoading = false
                this.obj.reject_reason = ''
                this.obj.status = ''
                this.$refs.form.reset()
            }).catch(response => {
                this.showLoading = false
                if(response && response.data) {
                    this.$refs.form.setErrors(response.data);
                    this.errMessage = this.$t('tags.'+ response.tag)
                }
            })
        }
    }
}
</script>
